import { createContext, useContext } from 'react';

import { PropertyFields } from '__generated__/api';

export interface GalleryPlaceholderData {
  propertyGallery: {
    images: PropertyFields.PropertyGallery[];
  };
}

export interface SummaryPlaceholderData {
  summary: {
    name: string;
    overview: {
      vipMessaging: string;
      starRating: number;
    };
    starRatingIcon: {
      id: string;
    };
  };
}

export interface ExtendedProperty extends PropertyFields.Fragment {
  getGalleryPlaceholderData: () => GalleryPlaceholderData;
  getSummaryPlaceholderData: () => SummaryPlaceholderData;
}

export const PropertyListingContext = createContext({} as ExtendedProperty);

export function usePropertyListing() {
  return useContext(PropertyListingContext);
}
